"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _TextField = _interopRequireDefault(require("@material-ui/core/TextField"));

var _CheckCircleOutline = _interopRequireDefault(require("@material-ui/icons/CheckCircleOutline"));

var _form = require("@widergy/web-utils/lib/form");

var _array = require("@widergy/web-utils/lib/array");

var _UTTooltip = _interopRequireDefault(require("../UTTooltip"));

var _UTLabel = _interopRequireDefault(require("../UTLabel"));

var _WithTheme = _interopRequireDefault(require("../WithTheme"));

var _theme = require("./theme");

var _constants = require("./constants");

var _stylesModule = _interopRequireDefault(require("./styles.module.scss"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var UTPhoneInput = /*#__PURE__*/function (_PureComponent) {
  _inherits(UTPhoneInput, _PureComponent);

  function UTPhoneInput() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, UTPhoneInput);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(UTPhoneInput)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      areaCode: '',
      phoneNumber: '',
      city: null,
      initialized: false
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      if (_this.props.input && _this.props.input.value && !_this.state.initialized) {
        _this.handleInitializeField();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "cleanField", function () {
      return _this.setState({
        areaCode: '',
        phoneNumber: ''
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleInitializeField", function () {
      var areaCode;
      var phoneNumber;
      var value = _this.props.input.value;

      if (_typeof(value) === 'object' && _this.props.childKeys) {
        areaCode = value[_this.props.childKeys[0]];
        areaCode = typeof areaCode === 'number' ? areaCode.toString() : areaCode;
        phoneNumber = value[_this.props.childKeys[1]];
        phoneNumber = typeof phoneNumber === 'number' ? phoneNumber.toString() : phoneNumber;
      } else {
        var stringValue = value.toString();
        areaCode = stringValue.slice(0, stringValue.indexOf('-'));
        phoneNumber = stringValue.slice(stringValue.indexOf('-') + 1);
      }

      _this.setState({
        initialized: true
      });

      _this.setState({
        areaCode: areaCode,
        phoneNumber: phoneNumber
      }, function () {
        return _this.handleValidateAreaCode(_this.state.areaCode);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleValidateAreaCode", function (areaCode) {
      if (areaCode.slice(0, 1) === '0') {
        _this.setState({
          error: _this.props.errors.codeWithZero
        });
      } else {
        var code = _constants.AREA_CODES.find(function (element) {
          return element.code === areaCode;
        });

        var error = areaCode.length && !code && _this.props.errors.invalidCode;

        _this.setState({
          error: error,
          city: code && code.city
        }, function () {
          if (_this.state.city && !error) _this.handleValidatePhoneNumber(_this.state.phoneNumber);
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleCleanPhoneNumber", function () {
      return _this.setState({
        phoneNumber: ''
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleValidatePhoneNumber", function (phoneNumber) {
      if (phoneNumber.slice(0, 1) === '0') {
        _this.setState({
          error: _this.props.errors.phoneWithZero
        });
      } else if (phoneNumber.slice(0, 2) === '15') {
        _this.setState({
          error: _this.props.errors.phoneWithFifteen
        });
      } else if (phoneNumber.length === 0) {
        _this.setState({
          error: _this.props.errors.numberNotEmpty
        });
      } else _this.setState({
        error: undefined
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleChangeAreaCode", function (event) {
      _this.setState({
        initialized: true
      });

      var areaCode = event.target.value.slice(0, 4);

      if (!areaCode) {
        _this.setState({
          areaCode: areaCode
        }, function () {
          _this.handleChange("".concat(_this.state.areaCode).concat(_this.state.phoneNumber));
        });
      } else {
        _this.setState({
          areaCode: areaCode
        }, function () {
          _this.handleChange("".concat(_this.state.areaCode, "-").concat(_this.state.phoneNumber));
        });
      }

      _this.handleCleanPhoneNumber();

      _this.handleValidateAreaCode(areaCode);
    });

    _defineProperty(_assertThisInitialized(_this), "handleChangePhone", function (event) {
      var phoneNumber = event.target.value.slice(0, 10 - _this.state.areaCode.length);

      _this.setState({
        phoneNumber: phoneNumber
      }, function () {
        _this.handleChange("".concat(_this.state.areaCode, "-").concat(_this.state.phoneNumber));
      });

      _this.handleValidatePhoneNumber(phoneNumber);
    });

    _defineProperty(_assertThisInitialized(_this), "handleKeyPress", function (event) {
      var regexp = /[0-9]+/g;

      if (!regexp.test(event.key)) {
        event.preventDefault();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleChange", function (initialValue) {
      var value = initialValue;
      var _this$props = _this.props,
          childKeys = _this$props.childKeys,
          field = _this$props.field,
          input = _this$props.input;

      if (childKeys) {
        var splittedPhone = value.split('-');
        value = _objectSpread({}, !(0, _array.isEmpty)(splittedPhone[0]) && _defineProperty({}, childKeys[0], splittedPhone[0]), {}, !(0, _array.isEmpty)(splittedPhone[1]) && _defineProperty({}, childKeys[1], splittedPhone[1]));
      } else if (field.configuration && field.configuration.without_dash) {
        value = initialValue.replace('-', '');
      }

      input.onChange(value);
    });

    return _this;
  }

  _createClass(UTPhoneInput, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.input && this.props.input.value && !this.state.areaCode && !this.state.initialized) {
        this.handleInitializeField();
      }

      if (this.state.initialized && prevProps.input && prevProps.input.value && this.props.input && (!this.props.input.value || this.props.input.value.length === 0)) {
        this.cleanField();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          field = _this$props2.field,
          input = _this$props2.input,
          disabled = _this$props2.disabled,
          meta = _this$props2.meta,
          classes = _this$props2.classes,
          placeholder = _this$props2.placeholder,
          label = _this$props2.label;
      return _react["default"].createElement("div", {
        className: "".concat(_stylesModule["default"].container, " ").concat(this.props.style)
      }, _react["default"].createElement("div", {
        className: _stylesModule["default"].inputContainer
      }, _react["default"].createElement("div", {
        className: _stylesModule["default"].areaCode
      }, _react["default"].createElement(_TextField["default"], {
        name: "area_code",
        type: "tel",
        label: field.configuration && field.configuration.area_code_label || _constants.AREA_CODE_LABEL,
        placeholder: field.configuration && field.configuration.area_code_placeholder || _constants.AREA_CODE_PLACEHOLDER,
        autoComplete: "off",
        fullWidth: true,
        margin: "none",
        onKeyPress: this.handleKeyPress,
        onFocus: this.handleFocus,
        onChange: this.handleChangeAreaCode,
        onBlur: this.handleBlur,
        value: this.state.areaCode,
        error: this.state.error || ((0, _form.shouldShowErrors)(meta) ? meta.error : ''),
        disabled: disabled
      }), _react["default"].createElement(_UTTooltip["default"], {
        content: this.state.city || ' '
      }, _react["default"].createElement("span", {
        className: "".concat(_stylesModule["default"].icon, " ").concat(this.state.city && _stylesModule["default"].showCheckedIcon)
      }, _react["default"].createElement(_CheckCircleOutline["default"], {
        tabIndex: "-1",
        className: "".concat(_stylesModule["default"].checkedIcon, " ").concat(classes.areaCodeIcon)
      })))), _react["default"].createElement("div", {
        className: _stylesModule["default"].phoneNumber
      }, _react["default"].createElement(_TextField["default"], {
        name: "phone_number",
        type: "tel",
        margin: "none",
        placeholder: placeholder,
        label: label,
        onKeyPress: this.handleKeyPress,
        autoComplete: "off",
        fullWidth: true,
        error: this.state.error || ((0, _form.shouldShowErrors)(meta) ? meta.error : ''),
        onFocus: input.onFocus,
        onChange: this.handleChangePhone,
        disabled: !this.state.city || disabled,
        value: this.state.phoneNumber
      }))), _react["default"].createElement(_UTLabel["default"], {
        error: true,
        className: classes.labelError
      }, this.state.error || ((0, _form.shouldShowErrors)(meta) ? meta.error : '')));
    }
  }]);

  return UTPhoneInput;
}(_react.PureComponent);

UTPhoneInput.propTypes = {
  input: (0, _propTypes.shape)({
    name: _propTypes.string.isRequired,
    onBlur: _propTypes.func.isRequired,
    onChange: _propTypes.func.isRequired,
    onFocus: _propTypes.func.isRequired,
    value: _propTypes.any.isRequired
  }),
  meta: (0, _propTypes.shape)({
    error: _propTypes.string
  }),
  placeholder: _propTypes.string,
  disabled: _propTypes.bool,
  label: _propTypes.string,
  // eslint-disable-next-line react/forbid-prop-types
  classes: _propTypes.any,
  errors: (0, _propTypes.shape)({
    codeWithZero: _propTypes.string,
    invalidCode: _propTypes.string,
    phoneWithFifteen: _propTypes.string,
    phoneWithZero: _propTypes.string,
    numberNotEmpty: _propTypes.string
  }),
  childKeys: (0, _propTypes.arrayOf)(_propTypes.string),
  // eslint-disable-next-line react/forbid-prop-types
  field: _propTypes.any
};
UTPhoneInput.defaultProps = {
  classes: {}
};

var _default = (0, _WithTheme["default"])(_theme.retrieveStyle, _theme.retrieveMuiTheme)(UTPhoneInput);

exports["default"] = _default;